import WithFocusRestore from './WithFocusRestore';

export default WithFocusRestore;
